import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { es, en } from 'vuetify/src/locale'

Vue.use(Vuetify, {
    iconfont: '[mdi, fa]',
})

export default new Vuetify({
    lang: {
        locales: { es, en },
        current:
            window.location.href.includes('localhost') ||
            window.location.href.includes('beereaders')
                ? 'es'
                : 'en',
    },
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#514585',
                secondary: '#ff6f3a',
                tertiary: '#ffb511',
                brown: '#4A3216',
                light: '#ffffff',
                primaryLight:'#EEECF8',
                darkText: '#323A46',
            },
            dark: {
                primary: '#514585',
                secondary: '#ff6f3a',
                tertiary: '#ffb511',
                brown: '#4A3216',
                light: '#ffffff',
                primaryLight:'#EEECF8',
                darkText: '#323A46',
            },
        },
    },
})
